<template>
  <div class="checkbox-input"
       :class="brandClass">
    <b-form-checkbox :id="`${id}Checkbox`"
                     :state="showError"
                     :disabled="disabled"
                     v-model="checked">
      <slot></slot>
    </b-form-checkbox>
  </div>
</template>

<script>
import Router from '../../../utility/routerUtil'

export default {
  name: 'checkbox-input',

  props: {
    id: {
      type: [String],
      default: 'defaultId'
    },

    hasError: {
      type: [Boolean],
      default: null
    },

    disabled: {
      type: [Boolean],
      default: false
    },

    value: {
      type: [Boolean],
      default: false
    }
  },

  data () {
    return {
      brandClass: Router.getCurrentRouteBrandClass(this.$route)
    }
  },

  computed: {
    showError () {
      return this.hasError === true ? false : null
    },

    checked: {
      get () {
        return this.value
      },

      set (value) {
        this.$emit('input', value)
        this.$emit('change', value)
      }
    }
  }
}
</script>

<style scoped lang="scss">
@use '../../../assets/styles/colors';

::v-deep .custom-control-label {
  &::before {
    border: 1px solid colors.$gray-300;
  }

  &::after {
    top: 8px;
    left: -21.5px;
    width: 11px;
    height: 6px;
  }
}

.text-14 {
  ::v-deep .custom-control-label {
    padding-top: 0.125rem;
  }
}

::v-deep .custom-control-input:checked ~ .custom-control-label::before {
  background-color: transparent;
  border-color: colors.$gray-300;
}

::v-deep .custom-control-input:disabled ~ .custom-control-label::before {
  background-color: colors.$gray-200;
}

::v-deep .custom-control-input {
  &.is-valid {
    ~ .custom-control-label {
      color: colors.$gray-800;
    }
  }

  &.is-invalid {
    ~ .custom-control-label {
      color: colors.$gray-800;

      &::before {
        border-color: colors.$red-1;
      }
    }
  }

  &:focus {
    ~.custom-control-label {
      &::before {
        outline-offset: 3px;
        box-shadow: none;

        .c1l & {
          outline: colors.$c1l--orange-1 solid 3px;
        }

        .ccc & {
          outline: colors.$ccc--purple-1 solid 3px;
        }

        .ccf & {
          outline: colors.$ccf--orange-1 solid 3px;
        }

        .chs & {
          outline: colors.$chs--green-3 solid 3px;
        }

        .cic & {
          outline: colors.$cic--green-2 solid 3px;
        }

        .esm & {
          outline: colors.$esm--orange-1 solid 3px;
        }

        .inl & {
          outline: colors.$inl--yellow-1 solid 3px;
        }

        .tmx & {
          outline: colors.$tmx--blue-2 solid 3px;
        }
      }
    }
  }
}

::v-deep .custom-control-input:checked.is-invalid ~ .custom-control-label::before {
  background-color: transparent;
  border-color: colors.$red-1
}

::v-deep .custom-control-input:focus:not(:checked) ~ .custom-control-label::before {
  border-color: colors.$gray-300;
}

::v-deep .custom-control-input.is-invalid:focus:not(:checked) ~ .custom-control-label::before {
  border-color: colors.$red-1;
}

::v-deep .custom-checkbox {
  .custom-control-input {
    &:checked {
      ~ .custom-control-label {
        &::after {
          border-top: none !important;
          border-right: none !important;
          transform: rotate(-45deg);

          .c1l & {
            border: 2px solid colors.$c1l--orange-1;
          }

          .ccc & {
            border: 2px solid colors.$ccc--purple-1;
          }

          .ccf & {
            border: 2px solid colors.$ccf--navy-4;
          }

          .chs & {
            border: 2px solid colors.$chs--orange-2;
          }

          .cic & {
            border: 2px solid colors.$cic--green-2;
          }

          .esm & {
            border: 2px solid colors.$esm--orange-1;
          }

          .inl & {
            border: 2px solid colors.$inl--green-2;
          }

          .tmx & {
            border: 2px solid colors.$tmx--blue-1;
          }
        }
      }

      &.is-invalid {
        ~ .custom-control-label {
          &::after {
            border: 2px solid colors.$red-1;
          }
          &::before {
            border-color: colors.$red-1;
          }
        }
      }
    }

    &:checked:disabled {
      ~ .custom-control-label {
        &::after {
          border: 2px solid colors.$gray-600;
        }
        &::before {
          background-color: colors.$gray-200;
        }
      }
    }
  }
}

::v-deep input,
::v-deep label {
  cursor: pointer;
}
</style>
